import { Container, Row, Col, Carousel } from "react-bootstrap";
import sliderDesktop from "../../assets/img/slider.png";
import sliderMobile from "../../assets/img/slider-mobile.png";
import videoBackgroundDesktop from "../../assets/img/mustang/video_desktop.mp4";
import videoBackgroundMobile from "../../assets/img/mustang/video_mobile.mp4";
import Header from "../Header/Header";

const SliderPortada = () => {
  return (
    <Container fluid className="p-0 m-0" style={{ background: "#030158" }}>
      <Row className="p-0 m-0">
        <Col md={12} className="mx-auto p-0 m-0">
          <div className="d-md-block d-none p-0 m-0">
            <Carousel controls={false} indicators={false} className="p-0 m-0">
              <Carousel.Item key={1} className="p-0 m-0">
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderDesktop} alt="Montironi Jeep" />
                </a>
                <div className="boxConocelo">
                  <div className="w-100 d-flex justify-content-center flex-row align-items-center align-content-center">
                    <h1>
                      Encontrala primero en <b>Montironi</b>.
                    </h1>
                    <a
                      href={"#form"}
                      target={"_self"}
                      rel="noreferrer"
                      className="btn-blue-destacado  ps-5 pe-5 ms-4"
                      style={{ cursor: "pointer", textDecoration: "none", minHeight: "45px" }}
                    >
                      Vení a conocerla
                    </a>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel controls={false} indicators={false}>
              <Carousel.Item key={1}>
                <a href={"#form"} target={"_self"} rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderMobile} alt="Montironi Jeep" />
                </a>
                <div className="boxConocelo" style={{ bottom: "50px" }}>
                  <div className="w-100 d-flex justify-content-center flex-column align-items-center align-content-center">
                    <h1 className="pb-2">
                      Encontrala primero en <b>Montironi</b>.
                    </h1>
                    <a
                      href={"#form"}
                      target={"_self"}
                      rel="noreferrer"
                      className="btn-blue-destacado  ps-5 pe-5 ms-4"
                      style={{ cursor: "pointer", textDecoration: "none", minHeight: "45px" }}
                    >
                      Vení a conocerla
                    </a>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SliderPortada;
